import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ValidatorService } from 'app/core/service/app/validator.service';
import { FormBaseComponent } from 'app/form/core/component/form-base/form-base.component';

@Component({
  selector: 'app-obligado-solidario',
  templateUrl: './obligado-solidario.component.html',
  styleUrls: ['./obligado-solidario.component.scss']
})
export class ObligadoSolidarioComponent extends FormBaseComponent<any> implements OnInit {

  constructor(private validatorService: ValidatorService) {
    super();

  }

  ngOnInit() {
    this.init(true);
  }

  template() {
    this.form.addControl('nombre', new FormControl(""));
    this.form.addControl('apellidoPaterno', new FormControl(""));
    this.form.addControl('apellidoMaterno', new FormControl(""));
    this.form.addControl('correo', new FormControl("", [Validators.email]));
    this.form.addControl('telefono', new FormControl("", [this.validatorService.telefono]));
    this.form.addControl('noIdentificacion', new FormControl(""));
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/obligado-solidario/obligado-solidario.component.ts